// @flow
import React, { useCallback } from 'react'
import { useSelector, shallowEqual } from 'react-redux'
import path from 'ramda/es/path'

import PaymentOrders from 'app/common/components/Finances/PaymentOrders'
import Loading from 'app/common/components/Loader'

import FinancesSubNavigation from './FinancesSubNavigation'
import selectPerson, { type Person } from '../selectPerson'
import getBaseUrl from '../getBaseUrl'
import useSchoolAsCamp from '../useSchoolAsCamp'

type Props = {
  params: {
    id: string,
    schoolType: string,
  },
  router: {
    push: (path: string) => void,
  },
}

const PaymentOrdersPage = ({ params: { id, schoolType }, router: { push } }: Props) => {
  const { loading, data } = useSelector((state) => state.students, shallowEqual)
  const hasPaymentOrders = path([id, 'hasPaymentOrders'], data)
  const person: Person = useSelector((state) => selectPerson(state, id))

  const baseUrl = getBaseUrl({ id, schoolType })
  const school = useSchoolAsCamp(id, schoolType)

  const getPaymentPath = useCallback(
    (amount: string) => {
      return `/finances/fund/refill?amount=${amount}&studentId=${id}`
    },
    [id],
  )

  if (!hasPaymentOrders) {
    push(`${baseUrl}/finances`)
  }

  if (!hasPaymentOrders || loading) {
    return <Loading />
  }

  return (
    <PaymentOrders
      school={school}
      person={person}
      getPaymentPath={getPaymentPath}
      bannerPlaceId="d099e4c6-f44b-42ef-b5f9-a1d52c27dee5"
      subNavigation={hasPaymentOrders ? <FinancesSubNavigation baseUrl={baseUrl} /> : null}
      hideHeader
    />
  )
}

export default PaymentOrdersPage
